<div *ngIf="!sharedContactForm">
  <div class="content-wrapper">
    <section class="wrapper image-wrapper bg-image bg-overlay bg-overlay-400 text-white" data-image-src="./assets/img/photos/bg3.jpg">
      <div class="container pt-17 pb-20 pt-md-19 pb-md-21 text-center">
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <h1 class="display-1 mb-3 title">{{landingPageData?.company?.title}}</h1>
            <nav class="d-inline-block" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/">{{'landing.home' | translateWithKeys}}</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{'landing.contact' | translateWithKeys}}</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>

    <section class="wrapper bg-light angled upper-end mb">
      <div class="container pb-11">
        <div class="row mb-14 mb-md-16">
          <div class="col-xl-10 mx-auto mt-n19">
            <div class="card">
              <div class="row gx-0">
                <div class="col-lg-6 align-self-stretch">
                  <div class="map map-full rounded-top rounded-lg-start" id="map">
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="p-10 p-md-11 p-lg-14">
                    <div class="d-flex flex-row">
                      <div>
                        <div class="icon text-primary fs-28 me-4 mt-n1"> <i class="uil uil-location-pin-alt"></i> </div>
                      </div>
                      <div class="align-self-start justify-content-start">
                        <h5 class="mb-1">{{'landing.address' | translateWithKeys}}</h5>
                        <address>{{landingPageData?.company?.address}}</address>
                      </div>
                    </div>

                    <div class="d-flex flex-row tel">
                      <div>
                        <div class="icon text-primary fs-28 me-4 mt-n1"> <i class="uil uil-phone-volume"></i> </div>
                      </div>
                      <div>
                        <h5 class="mb-1">{{'landing.phone' | translateWithKeys}}</h5>
                        <a href="tel:{{landingPageData?.company?.phone}}">{{landingPageData?.company?.phone}}</a>
                      </div>
                    </div>

                    <div class="d-flex flex-row">
                      <div>
                        <div class="icon text-primary fs-28 me-4 mt-n1"> <i class="uil uil-envelope"></i> </div>
                      </div>
                      <div>
                        <h5 class="mb-1">{{'landing.email' | translateWithKeys}}</h5>
                        <p class="mb-0"><a href="mailto:{{landingPageData?.company.email}}" class="link-body">{{landingPageData?.company?.email}}</a></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            <h2 class="display-4 mb-3 text-center">{{landingPageData?.company?.contactFormTitle}}</h2>
            <p class="lead text-center mb-10">{{landingPageData?.company?.contactFormDescription}}</p>
            <div class="messages"></div>
              <div class="row gx-4">
                <div class="col-md-6">
                  <app-mat-form-field class="full-width" [appearance]="'outline'" [model]="model" [hideCleanButton]="true" label="{{'landing.name' | translateWithKeys}}" property="name"></app-mat-form-field>
                </div>

                <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <app-mat-form-field class="full-width" [appearance]="'outline'" [model]="model" [hideCleanButton]="true" label="{{'landing.last_name' | translateWithKeys}}" property="lastName"></app-mat-form-field>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <app-mat-form-field class="full-width" [appearance]="'outline'" [model]="model" [hideCleanButton]="true" label="{{'landing.email' | translateWithKeys}}" property="emailFrom"></app-mat-form-field>
                  </div>
                </div>

                <div class="col-md-6">
                    <div class="form-floating mb-4">
                      <app-mat-form-field class="full-width" [appearance]="'outline'" [model]="model" [hideCleanButton]="true" label="{{'landing.phone' | translateWithKeys}}" property="phone"></app-mat-form-field>
                    </div>
                </div>

                <div class="col-12">
                  <div class="form-floating mb-4">
                    <mat-form-field class="full-width" appearance="outline" >
                        <mat-label>{{'landing.message' | translateWithKeys}}</mat-label>
                        <textarea matInput [(ngModel)]="model.message"></textarea>
                      </mat-form-field>
                  </div>
                </div>

                <div class="col-12 text-center">
                  <!-- <div [ngClass]="{'hidden': !model.name || !model.emailFrom || !model.message }" class="captcha-container">
                    <re-captcha (resolved)="validateCaptcha($event)" [siteKey]="captchaKey"></re-captcha>
                  </div> -->
                  <button [disabled]="!model.name || !model.emailFrom || !model.message || !model.phone" class="btn btn-primary rounded-pill btn-send mb-3" color="primary" (click)="send()">{{'landing.send_message' | translateWithKeys}}</button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="progress-wrap">
    <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
    </svg>
  </div>
</div>


<div *ngIf="sharedContactForm" class="default-white-background-color">
  <div class="container">
    <div class="card bg-soft-primary">
      <div class="card-body p-12">
        <div class="row gx-md-8 gx-xl-12 gy-10">
          <div class="col-lg-6">
            <img src="../../assets/img/icons/lineal/contact_icon.svg" class="icon-svg icon-svg-sm mb-4" alt="contact" />
            <h2 class="title-style display-4 mb-3 pe-lg-10">{{ modelAB?.contactTitle }}</h2>
            <p class="lead pe-lg-12 mb-0">
              {{ modelAB?.contactSubtitle }}
            </p>
          </div>

          <div class="col-lg-6">
              <div class="messages"></div>
              <div class="row gx-4">
                <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <app-mat-form-field class="full-width" [appearance]="'outline'" [model]="model" [hideCleanButton]="true" label="{{'landing.name' | translateWithKeys}}" property="name"></app-mat-form-field>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <app-mat-form-field class="full-width" [appearance]="'outline'" [model]="model" [hideCleanButton]="true" label="{{'landing.email' | translateWithKeys}}" property="emailFrom"></app-mat-form-field>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-floating mb-4">
                    <mat-form-field class="full-width" appearance="outline" >
                        <mat-label>{{'landing.message' | translateWithKeys}}</mat-label>
                        <textarea matInput [(ngModel)]="model.message"></textarea>
                      </mat-form-field>
                  </div>
                </div>

                <div class="col-12 alignment">
                  <button [disabled]="!model.name || !model.emailFrom || !model.message" class="btn-height btn btn-outline-primary rounded-pill btn-send mb-3" color="primary" (click)="send()">{{'landing.send_message' | translateWithKeys}}</button>
                  <!-- <div [ngClass]="{'hidden': !model.name || !model.emailFrom || !model.message }" class="captcha-container">
                    <re-captcha (resolved)="validateCaptcha($event)" siteKey="{{captchaKey}}"></re-captcha>
                  </div> -->
                </div>

              </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</div>
